"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FilterSideMenu = function FilterSideMenu(_ref) {
  var children = _ref.children;
  return _react["default"].createElement(_styled.StyledFilterSideMenu, null, _react["default"].createElement(_knotchWebReactComponents["default"], {
    "padding-top": "30px"
  }, children));
};

var _default = FilterSideMenu;
exports["default"] = _default;

//# sourceMappingURL=FilterSideMenu.js.map